import Catena from "../assets/images/Catena Zapata Malbec Argentino (1).jpg"
import Caymus from "../assets/images/Caymus Vineyards Cabernet Sauvignon.jpg";
import Cartillon from "../assets/images/Château Du Cartillon.jpg"
import Margaux from "../assets/images/Château Margaux 2009.jpg";
import Rothschild from "../assets/images/Château Mouton Rothschild.jpg";
import Sauternes from "../assets/images/Château d'Yquem Sauternes.jpg";
import Pinot from "../assets/images/Cloudy Bay Pinot Noir.jpg";
import Blanc from "../assets/images/Cloudy Bay Sauvignon Blanc.jpg"
import Domaine from "../assets/images/Domaine de la Romanée-Conti La Tâche.jpg";
import Grand_Cru from "../assets/images/Domaine de la Romanée-Conti Romanée-Conti Grand Cru.jpg";
import Vintage from "../assets/images/Dom Pérignon Vintage Champagne.jpg";

const wines = [
  {
    id: "1",
    name: "Catena Zapata Malbec Argentino",
    price: 24.99,
    image: Catena,
  },
  {
    id: "2",
    name: "Caymus Vineyards Cabernet Sauvignon",
    price: 19.99,
    image: Caymus,
  },
  {
    id: "3",
    name: "Château Du Cartillon",
    price: 21.99,
    image: Cartillon,
  },
  {
    id: "4",
    name: "Château Margaux 2009",
    price: 21.99,
    image: Margaux,
  },
  {
    id: "5",
    name: "Château Mouton Rothschild",
    price: 21.99,
    image: Rothschild,
  },
  {
    id: "6",
    name: "Château d'Yquem Sauternes 2011",
    price: 21.99,
    image: Sauternes,
  },
  {
    id: "7",
    name: "Cloudy Bay Pinot Noir",
    price: 21.99,
    image: Pinot,
  },
  {
    id: "8",
    name: "Cloudy Bay Sauvignon Blanc",
    price: 21.99,
    image: Blanc,
  },
  {
    id: "9",
    name: "Domaine de la Romanée-Conti La Tâche",
    price: 61.99,
    image: Domaine,
  },
  {
    id: "10",
    name: "Domaine de la Romanée-Conti Romanée-Conti Grand Cru",
    price: 55.99,
    image: Grand_Cru,
  },
  {
    id: "11",
    name: "Dom Pérignon Vintage Champagne",
    price: 62.99,
    image: Vintage,
  },
  // Add more wine products as needed
];

export default wines;
